module.exports = __webpack_public_path__ + "img/retailer_item_delete.5508e404.svg";